<template>
  <b-container class="center-content-container" :class="{ 'height100vh': !maxHeight }">
    <div class="iq-card modern-select-card">
      <div class="iq-card-header">
        <div v-if="!hideHeader" class="iq-header-title w-100">
          <div class="py-3 text-center">
            <h4 class="card-title mb-2">Select Company</h4>
            <h6 class="text-center text-muted">Select your company to continue.</h6>
          </div>
        </div>
      </div>
      <div class="iq-card-body">
        <div class="modern-select-wrapper">
          <b-card v-for="availableGroup in availableGroups" :key="availableGroup.grcpId" no-body class="accordion-card">
            <b-card-header header-tag="header" role="tab" class="p-0">
              <b-button
                class="group-header-button"
                block
                v-b-toggle="'select-group-' + availableGroup.grcpId"
                @click="onGroupSelected(availableGroup)"
              >
                {{ availableGroup.grcpName }}
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'select-group-' + availableGroup.grcpId"
              accordion="select-group-company-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <button
                  v-for="availableCompany in availableGroup.availableCompanies"
                  :key="availableCompany.compId"
                  @click="onCompanySelected(availableCompany)"
                  class="selection-card"
                  :class="{ 'selection-card-active': selected.company && selected.company.compId === availableCompany.compId }"
                >
                  {{ availableCompany.compName }}
                </button>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="pull-right mt-4">
              <button @click="onConfirmSelection" :disabled="!selected.group || !selected.company || isLoading" class="btn btn-primary modern-confirm-button">
                <i v-if="isLoading" class="ri-loader-line mr-2"></i>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'CompanyActiveSelection',
  props: ['hideHeader', 'maxWidth', 'disableRedirection', 'maxHeight'],
  data() {
    return {
      isLoading: false,
      selected: {
        group: undefined,
        company: undefined,
      },
      availableGroups: [],
    };
  },
  async created() {
    const groups = this.$store.getters['auth/availableGroup'];
    const companies = this.$store.getters['auth/availableCompany'];
    this.availableGroups = groups.map((group) => ({
      ...group,
      availableCompanies: Object.values(companies).filter((company) => company.compGrcpId === group.grcpId),
    }));

    const activeCompany = this.$store.state.auth.activeCompany;
    if (activeCompany) {
      this.selected.company = activeCompany;
      this.selected.group = this.availableGroups.find((g) => g.grcpId === activeCompany.compGrcpId);
    }

    // Cuma 1 company yang bisa dipilih - skip picker, auto-confirm. Jangan skip kalau
    // ini dibuka sebagai modal switcher (disableRedirection), biar switcher tetep guna.
    const allCompanies = Object.values(companies);
    if (!this.disableRedirection && allCompanies.length === 1) {
      const onlyCompany = allCompanies[0];
      this.selected.company = onlyCompany;
      this.selected.group = this.availableGroups.find((g) => g.grcpId === onlyCompany.compGrcpId);
      await this.onConfirmSelection();
    }
  },
  methods: {
    async onConfirmSelection() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('auth/changeActiveCompany', this.selected);

        if (this.disableRedirection) {
          await this.$store.dispatch('asset/resetAssetsData');
          await this.$store.dispatch('filter/resetCurrentMassId');
          this.$store.dispatch('triggerRemount');
          this.$store.dispatch('alertIncident/fetch');
          this.$bvModal.hide('select-company-modal');
        } else {
          this.$router.push({ name: 'AppActiveSelection' });
        }
      } catch (error) {
        console.error('Error confirming company selection:', error);
      } finally {
        this.isLoading = false;
      }
    },
    onCompanySelected(company) {
      this.selected.company = company;
    },
    // Mengembalikan metode ini untuk melacak grup yang dipilih
    onGroupSelected(group) {
      this.selected.group = group;
      // Mengosongkan pilihan company saat grup berbeda dipilih
      if (!this.selected.company || this.selected.company.compGrcpId !== group.grcpId) {
        this.selected.company = undefined;
      }
    },
  },
};
</script>

<style scoped>
/* Gaya utama yang dipertahankan */
body {
  background-color: #f8f9fa;
}
.center-content-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
}
.height100vh {
  min-height: 100vh;
}
.modern-select-card {
  width: 100%;
  max-width: 450px;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  background-color: white;
  overflow: hidden;
  padding: 20px;
}
.iq-card-header {
  border-bottom: none;
  padding-bottom: 0;
}
.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #343a40;
}
.text-muted {
  color: #6c757d !important;
  font-size: 0.9rem;
}
.iq-card-body {
  padding: 0;
}
.modern-select-wrapper {
  margin-top: 20px;
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
}
/* Gaya spesifik untuk akordion */
.accordion-card {
  border: none !important;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  border-radius: 8px !important;
  overflow: hidden;
}
.group-header-button {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  color: #343a40;
  font-weight: 600;
  text-align: left;
  padding: 12px 15px;
  border-radius: 0; /* Dihapus agar menyatu dengan card */
}
.group-header-button:hover {
  background-color: #f1f3f5;
}
.group-header-button.not-collapsed {
  background: linear-gradient(to right, #ff69b4, #ff3d9a);
  color: white;
  border-color: transparent;
}
.b-card-body {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/* Gaya untuk tombol pilihan perusahaan */
.selection-card {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  color: #343a40;
}
.selection-card:hover {
  border-color: #adb5bd;
  transform: translateY(-2px);
}
.selection-card-active {
  background: linear-gradient(to right, #ff69b4, #ff3d9a);
  color: white;
  border-color: transparent;
  font-weight: 500;
}
.selection-card-active:hover {
  transform: translateY(0);
}
/* Gaya untuk tombol konfirmasi */
.modern-confirm-button {
  background: linear-gradient(to right, #ff69b4, #ff3d9a);
  border: none;
  color: white;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 8px;
  transition: opacity 0.3s ease;
  margin-top: 20px;
  width: 100%;
}
.modern-confirm-button:hover {
  opacity: 0.9;
}
.modern-confirm-button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}
/* Lainnya */
.ri-loader-line {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
